function AddProduct(props) {

    let {addProduct} = props

    return (
        <div>
            <div className='button_elem'>
                <button id='add' onClick={() => addProduct()}>Добавить новый товар</button>
            </div>
        </div>
    )
}

export default AddProduct